<div [ngClass]="{'template-card': true, 'loading': isLoading, 'inactive': inactive}"
  (click)="inactive === false && selectTemplate()" [class.mat-elevation-z2]
  [style.background-image]="'url(' + template.path + ')'">
  <div class="template-header">
    <div class="template-title">{{template.title}}</div>
    <div class="template-icons">
      <mat-icon>{{template.isMulti ? 'group' : 'person'}}</mat-icon>
      <mat-icon *ngIf="template.is360Only">360</mat-icon>
    </div>

  </div>
  <div class="template-overlay"></div>
  <div *ngIf="!hasFailed && !isLoading" class="template-desc">{{template.description}}</div>
  <div *ngIf="!hasFailed && isLoading" class="template-loader">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>
  <div *ngIf="hasFailed" class="template-error">
    Error while creating the Experience.<br />
    Please refresh.
  </div>
</div>